import { Map, List } from 'immutable';

export function isAdmin(userLevels) {
  const adminLevels = ['roster_manager', 'organisation_admin', 'payroll_officer', 'manager'];
  return userLevels.filter(level => adminLevels.includes(level)).length > 0;
}

export function createEmployee(employee) {
  return new Map({
    id: employee.id,
    name: employee.name,
    passcode: employee.passcode,
    departmentIds: new List(employee.department_ids),
    dateOfBirth: employee.date_of_birth,
    userLevels: new List(employee.user_levels),
    schedules: new Map(),
    clockedIn: false,
    admin: isAdmin(employee.user_levels),
  });
}

export function setEmployeeClockState(state, id, type = 'in') {
  if (type !== 'in' && type !== 'out') {
    return state;
  }

  const clocked = type === 'in';
  try {
    return state.update(state.findIndex(emp => emp.get('id') === id), emp =>
      emp.set('clockedIn', clocked));
  } catch (e) {
    // employee with that id doesn't exist
    return state;
  }
}

export function updateClockedInList(state, clockedIn) {
  return state.map((employee) => {
    if (clockedIn.includes(employee.get('id'))) {
      return employee.set('clockedIn', true);
    }
    return employee.set('clockedIn', false);
  });
}

export function generateClockObject(clockObject, image, delta = 0) {
  if (!clockObject) {
    throw new Error('Clock Object must be provided');
  }
  // clone the provided object
  const clockDetails = { ...clockObject };

  if (clockDetails.user_id == null || Number.isNaN(parseInt(clockDetails.user_id, 10))) {
    throw new Error('User\'s ID must be present.');
  }

  if (clockDetails.type !== 'clockin' && clockDetails.type !== 'clockout') {
    throw new Error('Clock type must be one of [\'clockin\', \'clockout\']');
  }

  if (clockDetails.time == null) {
    throw new Error('Clock time must be set');
  }

  clockDetails.time = Math.floor((clockDetails.time - delta) / 1000);

  if (
    image
    && image.length > 22 // check if image is longer than the dataURL identifier
    && (image.length - 22) % 4 === 0 // checking if data is correctly encoded
    && image.startsWith('data:image/png;base64,') // contains correct dataURL identifier
  ) {
    clockDetails.photo = image;
  }
  return clockDetails;
}



// WEBPACK FOOTER //
// ./src/store/employees/lib.js